import { Skeleton } from '@/components/atoms';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

/**
 * Skeleton component for PaymentSummaryCard
 * Matches the structure and dimensions of PaymentSummaryCard
 */
export function PaymentSummaryCardSkeleton() {
    const colors = useUIColors();

    return (
        <View style={[styles.card, { backgroundColor: colors.backgroundLevel1 }]}>
            {/* Header skeleton */}
            <View style={styles.header}>
                <View style={styles.titleContainer}>
                    <Skeleton width={160} height={20} />
                    <Skeleton width={120} height={16} style={{ marginTop: 4 }} />
                </View>
                <Skeleton width={20} height={20} variant="circular" />
            </View>

            {/* Stats container skeleton */}
            <View style={styles.statsContainer}>
                <View style={styles.statItem}>
                    <View style={styles.statHeader}>
                        <Skeleton width={18} height={18} variant="circular" />
                        <Skeleton width={30} height={20} style={{ marginLeft: 4 }} />
                    </View>
                    <Skeleton width={80} height={12} style={{ marginTop: 4 }} />
                </View>

                <View style={styles.statItem}>
                    <View style={styles.statHeader}>
                        <Skeleton width={18} height={18} variant="circular" />
                        <Skeleton width={30} height={20} style={{ marginLeft: 4 }} />
                    </View>
                    <Skeleton width={100} height={12} style={{ marginTop: 4 }} />
                </View>

                {/* Optional third stat (total outstanding) */}
                <View style={styles.statItem}>
                    <View style={styles.statHeader}>
                        <Skeleton width={16} height={16} variant="circular" />
                        <Skeleton width={60} height={16} style={{ marginLeft: 4 }} />
                    </View>
                    <Skeleton width={90} height={12} style={{ marginTop: 4 }} />
                </View>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    card: {
        borderRadius: 12,
        paddingHorizontal: 12,
        paddingVertical: 16,
        gap: 20,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 4,
    },
    titleContainer: {
        flex: 1,
        gap: 4,
    },
    statsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
    },
    statItem: {
        flex: 1,
        gap: 4,
    },
    statHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
});

export default PaymentSummaryCardSkeleton;

